import { useQuery } from 'react-query';

import { IDENTITIES_KEY, Identity, getIdentity } from '../utils/backend-api/identities';

export default function useIdentity(id: number) {
  const { data: identity, isLoading: isIdentityLoading } = useQuery<Identity>(
    [IDENTITIES_KEY, id],
    () => getIdentity(id),
    {
      enabled: !!id,
    }
  );

  return { identity, isIdentityLoading };
}
